<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Power of Being Known: A Heart-Centered Journey Connecting to Self, Earth, Lineage, and Love</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#a-letter-from-the-author">A Letter from the Author</a></li>
<li id="toc-li-5"><a href="#/text/ch005#foreword">Foreword</a></li>
<li id="toc-li-6"><a href="#/text/ch006#part-i-knowing-your-self-begins-by-knowing-your-cells">Part I: Knowing Your Self Begins by Knowing Your Cells</a>
<ol><li id="toc-li-7"><a href="#/text/ch007#introduction">Introduction</a></li>
<li id="toc-li-8"><a href="#/text/ch008#chapter-1-you-are-one-cell-one-of-many">Chapter 1: You Are One Cell One of Many</a></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-2-you-receive-what-you-believe" title="Link target outside of Sample">Chapter 2: You Receive What You Believe</span></li></ol>
</li>
<li id="toc-li-10"><span href="#/text/ch010#part-ii-heart-connection-connects-you-to-all" title="Link target outside of Sample">Part II: Heart Connection Connects You to All</span>
<ol><li id="toc-li-11"><span href="#/text/ch011#chapter-3-tend-to-your-heart-shes-welcoming-you-home" title="Link target outside of Sample">Chapter 3: Tend to Your Heart, She’s Welcoming You Home</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-4-return-to-love" title="Link target outside of Sample">Chapter 4: Return to Love</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-5-everything-is-energy" title="Link target outside of Sample">Chapter 5: Everything Is Energy</span></li></ol>
</li>
<li id="toc-li-14"><span href="#/text/ch014#part-iii-from-who-am-i-to-i-am" title="Link target outside of Sample">Part III: From ‘Who Am I?’ To I Am</span>
<ol><li id="toc-li-15"><span href="#/text/ch015#chapter-6-generational-healing-creates-generational-wealth" title="Link target outside of Sample">Chapter 6: Generational Healing Creates Generational Wealth</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-7-unlock-the-alchemist-within-you" title="Link target outside of Sample">Chapter 7: Unlock the Alchemist Within You</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-8-embody-the-truth-of-who-you-are" title="Link target outside of Sample">Chapter 8: Embody the Truth of Who You Are</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-9-and-the-journey-continues" title="Link target outside of Sample">Chapter 9: And the Journey Continues</span></li></ol>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?1bfe6c06